import { config } from '../config';
import { getHeaders } from './getHeaders';

export const sendPasswordRecovery = (email: string) =>
  fetch(`${config.apiBaseUrl}/api/v1/roofer/password`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ email }),
  });
